module.exports = __webpack_public_path__ + "static/media/abt_icon4.7284a122.svg";